import { bonusPromotionsActions } from '../../../store/slices/bonusPromotions/slice';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreFreeChipsAvailableGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.FreeChipsAvailable;

  process(_message: GameCommunicationMessageType): void {
    this.store.dispatch(bonusPromotionsActions.setRefetchCampaign(true));
  }
}
